import { useEffect } from "react";
import { IChipLoadingProps } from "../../../constants/FinanceModels";
import ColouredChip from "../../../component/ColouredChip";
import { CircularProgress, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { COLOR_ERROR, COLOR_IMPORTED, ERROR, IMPORTED, PROCESSING } from "../constants/FuelsConstants";
import { useFuelCardsRepository } from "../../../api/repositories/FuelCardsRepository";
import { useFuelReportStatuses } from "../constants/useFuelReportStatuses";

function ChipDynamic(props: IChipLoadingProps) {

    const {getReportById} = useFuelCardsRepository();
    const {getReportStatus} = useFuelReportStatuses();

    const controller = new AbortController();
    const {t} = useTranslation('finance');
    const initialStatus = props.initialValue.toUpperCase();
    function showChip() {
        switch (initialStatus) {
            case IMPORTED:
                return (<ColouredChip name={getReportStatus(IMPORTED)} color={COLOR_IMPORTED}/>);
            case ERROR:
                return (<ColouredChip name={getReportStatus(ERROR)} color={COLOR_ERROR}/>);
            default:
                return (
                    <Stack display={"flex"} justifyContent={"center"} alignItems={"center"} sx={{ height: '35px' }} direction={'row'} spacing={1}>
                        <Typography fontSize={'small'}>
                            {t(`chips.${PROCESSING}`)}
                        </Typography>
                        <CircularProgress size={20}/>
                    </Stack>
                )
        }
    }

    function updateData() {
        getReportById(props.id, {signal: controller.signal})
            .then(response => {
                if (response.result.status !== initialStatus) {
                    props.data.status = response.result.status;
                    props.data.totalRefuelling = response.result.totalRefuelling;
                    props.redrawRows();
                } else {
                    setTimeout(() => updateData(), props.interval);
                }
            })
            .catch(() => {
                if (!controller.signal.aborted) {
                    setTimeout(() => updateData(), props.interval);
                }
            });
    }

    useEffect(() => {
        if (initialStatus === PROCESSING) {
            updateData();
        }
       /* return () => {
            controller.abort();
        }*/
    }, [])


    return (
        <>
            {showChip()}
        </>
    );
}

export default ChipDynamic;